import { WidgetProps } from './Widgets';
import { Textarea } from 'components';
import { cn } from 'domain/core';
import { useMemo } from 'react';

const DEFAULT_SIZE = 'h-20';

export const TextAreaComponent = ({
	value,
	uiSchema,
	onChange,
}: WidgetProps<string>) => {
	const asValue = useMemo(() => {
		if (!value) {
			return '';
		}
		if (value.constructor === String) {
			return value;
		}
		return '';
	}, [value]);

	const size = useMemo(() => {
		if (!uiSchema) {
			return DEFAULT_SIZE;
		}

		if (!uiSchema['ui:size']) {
			return DEFAULT_SIZE;
		}

		// Map 'md' and 'xl' to 'h-40' and 'h-48' respectively
		if (uiSchema['ui:size'] === 'md') {
			return 'h-32';
		}

		if (uiSchema['ui:size'] === 'xl') {
			return 'h-48';
		}

		return DEFAULT_SIZE;
	}, [uiSchema]);

	return (
		<div className='flex w-full flex-col items-center justify-between'>
			<Textarea
				className={cn('w-full rounded', size)}
				value={asValue}
				onChange={(e) => {
					onChange(e.target.value);
				}}
			/>
		</div>
	);
};
